/* eslint-disable @typescript-eslint/no-explicit-any */
import _get from 'lodash/get';

export interface AddTypenameToDataNodeMap {
    listKey: string;
    typename: string;
    recursionKey?: string;
    path?: string[];
}

export interface AddTypenameToObjectOrArrayInput {
    data?: any;
    path?: string[];
    typename: string;
    recursionKey?: string;
    nodeMaps?: AddTypenameToDataNodeMap[];
}

interface AddTypenameToObjectInput {
    item: any;
    typename: string;
    recursionKey?: string;
    nodeMaps?: AddTypenameToDataNodeMap[];
}

export const addTypenameToObjectOrArray = (
    addTypenameToObjectOrArrayInput: AddTypenameToObjectOrArrayInput,
): void => {
    const {
        data,
        nodeMaps = [],
        path,
        typename,
        recursionKey,
    } = addTypenameToObjectOrArrayInput;
    const objectOrArray = path ? _get(data, path) : data;
    let parentArray = null;

    if (objectOrArray === undefined) {
        // Check if the parent path node was an array
        parentArray = path ? _get(data, path.slice(0, path.length - 1)) : null;

        if (!Array.isArray(parentArray)) {
            return;
        }
    }

    const addTypenameToObject = (input: AddTypenameToObjectInput): void => {
        if (input.item === undefined) {
            return;
        }
        // eslint-disable-next-line no-param-reassign
        input.item['__typename'] = input.typename;

        if (input.recursionKey && input.item[input.recursionKey]) {
            addTypenameToObjectOrArray({
                data: input.item[input.recursionKey],
                nodeMaps: input.nodeMaps,
                typename: input.typename,
                recursionKey,
            });
        }

        for (const nodeMap of nodeMaps) {
            if (input.item[nodeMap.listKey] !== null) {
                addTypenameToObjectOrArray({
                    ...nodeMap,
                    data: input.item[nodeMap.listKey],
                });
            }
        }
    };

    if (Array.isArray(objectOrArray)) {
        objectOrArray.forEach(item => {
            if (item !== null) {
                addTypenameToObject({
                    item,
                    nodeMaps,
                    typename,
                    recursionKey,
                });
            }
        });
    } else if (typeof objectOrArray === 'object' && objectOrArray !== null) {
        addTypenameToObject({
            item: objectOrArray,
            nodeMaps,
            typename,
            recursionKey,
        });
    }

    if (Array.isArray(parentArray) && path) {
        const lastPathElement = [...path].pop();

        if (typeof lastPathElement === 'string') {
            parentArray.forEach(child => {
                const childArray = _get(child, [lastPathElement]);

                if (Array.isArray(childArray)) {
                    childArray.forEach(item => {
                        if (item !== null) {
                            addTypenameToObject({
                                item,
                                nodeMaps,
                                typename,
                                recursionKey,
                            });
                        }
                    });
                }
            });
        }
    }
};

export const addTypenamesToData = (
    data: any,
    typenameMaps: AddTypenameToObjectOrArrayInput[],
): void => {
    typenameMaps.forEach((typenameMap: AddTypenameToObjectOrArrayInput) => {
        addTypenameToObjectOrArray({ data, ...typenameMap });
    });
};
